module.exports = __webpack_public_path__ + "static/assets/f6f98a31ec06445bd1c27a3187ae25f0.png";